import { type SchoolAccess } from '@/mocks/overseasAccess';

type Props = { access: SchoolAccess; schoolName: string };

export default function SchoolAccessBlock({ access, schoolName }: Props) {
  const telHref = access.phone
    ? 'tel:' + access.phone.replace(/[^0-9+]/g, '')
    : undefined;

  return (
    <section>
      <h2 className="font-heading text-2xl text-foreground-900 tracking-[0.06em] mb-5 pb-4 border-b border-background-200">
        所在地とアクセス
      </h2>

      <dl>
        {access.address !== undefined && (
          <div>
            <dt>所在地</dt>
            <dd>
              {access.address}
              {access.mapQuery && (
                <>
                  {' '}
                  <a
                    href={
                      'https://www.google.com/maps/search/?api=1&query=' +
                      encodeURIComponent(access.mapQuery)
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Google マップで開く
                    <i className="ri-external-link-line" />
                  </a>
                </>
              )}
            </dd>
          </div>
        )}

        {access.phone !== undefined && (
          <div>
            <dt>電話</dt>
            <dd>
              <a href={telHref}>{access.phone}</a>
            </dd>
          </div>
        )}

        {access.email !== undefined && (
          <div>
            <dt>メール</dt>
            <dd>
              <a href={'mailto:' + access.email}>{access.email}</a>
            </dd>
          </div>
        )}

        {access.hours !== undefined && (
          <div>
            <dt>営業時間</dt>
            <dd>{access.hours}</dd>
          </div>
        )}

        {access.extra &&
          access.extra.map(function (item) {
            return (
              <div key={item.label}>
                <dt>{item.label}</dt>
                <dd>{item.value}</dd>
              </div>
            );
          })}
      </dl>

      {access.mapQuery && (
        <div className="mt-6 overflow-hidden border border-background-200">
          <iframe
            title={schoolName + ' の所在地'}
            src={
              'https://maps.google.com/maps?q=' +
              encodeURIComponent(access.mapQuery) +
              '&output=embed&hl=ja'
            }
            className="w-full h-[320px] md:h-[400px] border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      )}

      {access.mapNote && (
        <p className="text-[13px] text-foreground-500 mt-2 leading-relaxed">
          {access.mapNote}
        </p>
      )}
    </section>
  );
}
